<template>
  <basic-container>
    <el-form
      ref="searchForm"
      :model="query"
      label-width="100px"
      margin-top="0"
    >
      <el-row :gutter="0">
        <el-col :span="6">
          <el-form-item label="小区名称" prop="communityId">
            <el-select
              v-model="query.communityId"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in communityList"
                :key="index"
                :label="item.roomName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="业务来源" prop="businessSource">
            <el-select
              v-model="query.businessSource"
              clearable
              @change="businessSourceChange"
            >
              <el-option
                v-for="(item, index) in businessSourceList"
                :key="index"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="发票号码" prop="invoiceNo">
            <el-input v-model="query.invoiceNo" clearable placeholder="发票号码"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="发票类型" prop="invoiceType">
            <el-select
              v-model="query.invoiceType"
              clearable
            >
              <el-option
                v-for="(item, index) in taxInvoiceTypeList"
                :key="index"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="发票状态" prop="invoiceStatus">
            <el-select
              v-model="query.invoiceStatus"
              clearable
            >
              <el-option
                v-for="(item, index) in invoiceStatusList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="开票时间" prop="dateRange">
            <el-date-picker
              style="width:100%;"
              v-model="query.dateRange"
              type="daterange"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="发票标识" prop="invoiceFlag">
            <el-select
              v-model="query.invoiceFlag"
              clearable
            >
              <el-option
                v-for="(item, index) in invoiceFlagList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="text-align:right;">
        <el-form-item>
          <el-button size="small"
                     type="primary"
                     icon="el-icon-search"
                     native-type="submit"
                     @click.prevent="submitSearchForm">搜索
          </el-button >
          <el-button size="small"
                     type="white"
                     @click="searchReset"
                     icon="el-icon-delete">清空
          </el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :search.sync="searchForm"
               :page="page"
               :permission="permissionList"
               v-model="form"
               ref="crud"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">

      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          v-if="permissionList.redBtn
          && scope.row.invoiceStatus == 1
          && scope.row.invoiceFlag == 'blue'"
          @click="openInvoiceRed(scope.row)">红冲
        </el-button>
        <el-button
          type="text"
          size="small"
          v-if="permissionList.downloadBtn
          && scope.row.invoiceStatus == 1"
          @click="downloadFile(scope.row)">下载
        </el-button>
        <el-button
          type="text"
          v-if="scope.row.invoiceStatus == 2 && scope.row.invoiceFlag == 'blue' && permissionList.issueAgainBtn"
          @click="issueAgainWhenFail(scope.row)"> 重开
        </el-button>
      </template>

      <template slot="invoiceBillNo" slot-scope="scope">
        <div style="color: #409EFF;cursor: pointer;" @click="openTaxInvoiceDetailByBillNo(scope.row.invoiceBillNo)">
          <span>{{ scope.row.invoiceBillNo }}</span>
        </div>
      </template>

      <template slot="invoiceNoLink" slot-scope="scope">
        <div style="color: #409EFF;cursor: pointer;" @click="openTaxInvoiceDetailByLink(scope.row.invoiceNoLink)">
          <span>{{ scope.row.invoiceNoLink }}</span>
        </div>
      </template>
    </avue-crud>

    <el-dialog
      title="发票查看"
      width="60%"
      v-if="showDetail"
      :visible.sync="showDetail"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <TaxInvoiceDetail
        v-if="showDetail"
        :searchObj="searchDetailObj"
        @close="closeDetail"
      ></TaxInvoiceDetail>
    </el-dialog>

    <el-dialog
      title="红冲"
      width="40%"
      v-if="showRed"
      :visible.sync="showRed"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <TaxInvoiceRed
        v-if="showRed"
        :rowData="rowData"
        @close="closeRed"
      ></TaxInvoiceRed>
    </el-dialog>
    <InvoiceDownloadDialog ref="InvoiceDownloadDialog" />

    <el-dialog title="提示" width="40%"
               v-model="tipShow"
               :append-to-body="true"
               :modal-append-to-body="true"
               :close-on-click-modal="false"
               :destroy-on-close="true">
      <div class="plate-change-tip">
        <div class="t1">
          <span >开票失败！失败原因：{{failMsg}}</span>
          <br/>
          <span >请解决问题后，重新开票！</span>
        </div>
      </div>
      <template #footer>
        <div>
          <el-button @click="closeTipShow()">确 定</el-button>
        </div>
      </template>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  getPage,
  issueAgain,
  delHasInvoiceFail,
} from "@/api/v4ward/digitaltickets/taxinvoicerecord/TaxInvoiceRecord";
import {mapGetters} from "vuex";
import { getOptionNode } from "@/api/v4ward/property/baseproperty";
import { getDictionary } from '@/api/common.js';
import TaxInvoiceDetail from './compoents/TaxInvoiceDetail.vue';
import TaxInvoiceRed from './compoents/TaxInvoiceRed.vue';
import InvoiceDownloadDialog from '@/views/v4ward/digitaltickets/compoents/invoice-download-dialog';
import dayjs from "dayjs";
import { getInvoiceTypeList } from '@/api/v4ward/digitaltickets/invoiceType';

export default {
  components: {
    TaxInvoiceDetail,
    TaxInvoiceRed,
    InvoiceDownloadDialog,
  },
  data() {
    return {
      fileUrl:'',
      failMsg: '',
      tipShow: false,
      invoiceFlagList:[
        { label: '红票', value: 'red' },
        { label: '蓝票', value: 'blue' },
      ],
      showRed:false,
      rowData:{},
      showDetail:false,
      searchDetailObj:{},
      communityList:[],
      taxInvoiceTypeList:[],
      invoiceStatusList:[
        { label: '进行中', value: '0' },
        { label: '开票成功', value: '1' },
        { label: '开票失败', value: '2' },
        { label: '已红冲', value: '3' },
        { label: '开票中', value: '4' },
      ],
      businessSourceList:[],
      form: {
      },
      query: {
        communityId:'',
        businessSource:'',
        invoiceNo:'',
        invoiceType:'',
        invoiceStatus:'',
        dateRange:[],
        invoiceFlag:'',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      tempFeeTax: '',
      option: {
        labelWidth: 140,
        menuWidth: 120,
        // indexLabel:"序号",
        menu: true,
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        // searchBtn: false,
        // emptyBtn: false,
        searchMenuSpan: 18,
        border: true,
        // index: true,
        viewBtn: false,
        dialogClickModal: false,
        column: [
          {
            label: "发票记录编号",
            prop: "invoiceBillNo",
            width: 170,
            slot: true,
          },
          {
            label: "发票号码",
            prop: "invoiceNo",
            width: 160,
          },
          {
            label: "所属小区",
            prop: "communityName",
            width: 110,
            overHidden: true,
          },
          {
            label: "客户",
            prop: "customer",
            width: 110,
          },
          {
            label: "房号",
            prop: "roomName",
            width: 160,
            overHidden: true,
          },
          {
            label: "发票类型",
            prop: "invoiceTypeName",
            width: 120,
            overHidden: true
          },
          {
            label: "金额",
            prop: "payAmount",
          },
          {
            label: "发票标识",
            prop: "invoiceFlag",
            dicData: [
              { label: '红票', value: 'red' },
              { label: '蓝票', value: 'blue' },
            ],
          },
          {
            label: "红/蓝票号",
            prop: "invoiceNoLink",
            width: 160,
            overHidden: true,
            slot: true,
          },
          {
            label: "开票人",
            prop: "invoiceUser",
          },
          {
            label: "开票时间",
            prop: "invoiceTime",
            width: 130,
          },
          {
            label: "开票状态",
            prop: "invoiceStatus",
            dicData: [],
          },
          {
            label: "开票失败原因",
            prop: "blueErrorMsg",
            width: 130,
            overHidden: true,
          },
          {
            label: "红冲原因",
            prop: "redReason",
            dicData:[],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: "红冲失败原因",
            prop: "redErrorMsg",
            width: 130,
            overHidden: true,
          },
          {
            label: "销售方信息",
            prop: "sellerName",
            width: 120,
            overHidden: true,
          },
          {
            label: "业务来源",
            prop: "businessSourceName",
            width: 100,
          },
          {
            label: "开票来源",
            prop: "issueSource",
            dicData: [
              { label: '管理平台', value: 'PC' },
              { label: '小程序', value: 'CLIENT' },
            ],
          },
        ]
      },
      data: [],
      searchForm:{

      },
      feeTaxList: [],
    };
  },
  watch: {
  },
  mounted(){
    this.adjustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  created(){
    this.findObject(this.option.column, 'invoiceStatus').dicData = this.invoiceStatusList;
    this.initCommunityIds();
    getDictionary('invoice_red_reason').then((res) => {
      this.findObject(this.option.column,'redReason').dicData = res.data;
    });
    getDictionary('invoice_business_source').then((res) => {
      this.businessSourceList = res.data;
    });
    //初始票据类型下拉框
    getInvoiceTypeList().then(({data})=>{
      this.taxInvoiceTypeList = data;
    });
    this.onLoad();
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        downloadBtn: this.vaildData(this.permission.invoice_record_download, false),
        redBtn: this.vaildData(this.permission.invoice_record_red, false),
        issueAgainBtn: this.vaildData(this.permission.invoice_issue_again, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  },
  methods: {
    closeTipShow(){
      this.tipShow = false;
      this.onLoad();
    },
    issueAgainWhenFail(row){
      //初始化
      this.$confirm('是否重新开票?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        issueAgain(row).then((res) => {
          let data = res.data;
          if(data.success){
            this.onLoad();
            this.$message.success('开票成功!');
          }else{
            this.failMsg = data.failMsg;
            this.tipShow = true;
          }
        }, error => {
          window.console.log(error);
          console.log("error>>>", error);
          if(error && (error == 'Error: 存在已开票的记录' || error == 'Error: 存在进行中或已开票的临停支付记录，请检查数据！')){
            this.delHasInvoiceWhenFail(row);
          }
          loading();
        });
      });
    },
    //删掉已经开票的失败记录
    delHasInvoiceWhenFail(row){
      //初始化
      this.$confirm('当前失败记录对应的收费记录已经开票成功，是否删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        delHasInvoiceFail({id:row.id}).then(() => {
          this.$message.success('操作成功!');
          this.onLoad();
        }, error => {
          window.console.log(error);
          loading();
        });
      });
    },
    businessSourceChange(val1){
      if(val1 == '3' || val1 == '4'){
        this.query.communityId = '';
      }
    },
    downloadFile(row) {
      let invoiceData = Object.assign({}, row);
      this.$refs.InvoiceDownloadDialog.openDialog(invoiceData);
    },
    openTaxInvoiceDetailByBillNo(value){
      this.searchDetailObj = {invoiceBillNo:value};
      this.showDetail = true;
    },
    openTaxInvoiceDetailByLink(value){
      this.searchDetailObj = {invoiceNo:value};
      this.showDetail = true;
    },
    closeDetail(){
      this.searchDetailObj = {};
      this.showDetail = false;
    },
    openInvoiceRed(value){
      this.rowData = value;
      this.showRed = true;
    },
    closeRed(){
      this.rowData = {};
      this.showRed = false;
      this.onLoad();
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    adjustView() {
      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    initCommunityIds(){
      getOptionNode().then((res) => {
        this.communityList = res.data.filter(ele => ele.id != '-1');
        if(this.communityList){
          this.query.communityId = this.communityList[0].id;
          this.onLoad();
        }
      });
    },
    searchReset() {
      setTimeout(()=>{
        this.query.businessSource = '';
        this.query.invoiceNo = '';
        this.query.invoiceType = '';
        this.query.invoiceStatus = '';
        this.query.dateRange = [];
        this.query.invoiceFlag = '';
        this.query.startDate = '';
        this.query.endDate = '';
        this.onLoad();
      },0)
    },
    searchChange(params, done) {
      this.page.currentPage = 1;
      this.onLoad();
      // done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      if(!this.query.communityId && !this.query.businessSource){
        return;
      }
      this.loading = true;
      if(this.query.dateRange && this.query.dateRange[0]){
        this.query.startDate = dayjs(this.query.dateRange[0]).format('YYYY-MM-DD 00:00:00');
        this.query.endDate = dayjs(this.query.dateRange[1]).format('YYYY-MM-DD 23:59:59');
      }else{
        this.query.startDate = '';
        this.query.endDate = '';
      }
      getPage(
        Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
      ).then(({data}) => {
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    }
  }
};
</script>

<!--最大化-->
<style lang="scss" scoped>
::v-deep .el-form-item {
  width: 100%;
}
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}
</style>
